export default __webpack_public_path__ + "static/media/upView.c00aeed4.mp4";